/**
 * AboutOfferings: what the website's guest home adds to the About sheet after the guide
 * (shared-client-screens D3, AboutScreen's `afterGuide` slot; card 2 rows H5, H6, H7): the top
 * three services with See all, and Happening Soon with its event and series cards. Drawn from the
 * app's own Book screen card and Home row. Props only.
 */
import type { HubServiceDto } from '@/api/types';
import hubCss from '@/pages/BookingHubPage/BookingHubPage.module.css';
import { HappeningSoon } from '@/pages/BookingHubPage/sections/HappeningSoon';
import { ChevronRightIcon } from '@/pages/BookingHubPage/sections/icons';
import bookCss from '@/pages/BookSessionPage/BookSessionPage.module.css';
import { ServiceCatalogCard } from '@/pages/BookSessionPage/ServiceCatalogCard';
import type { HappeningSoonItem } from '@/types/dashboard';
import aboutCss from './AboutPage.module.css';
import css from './AboutScreen.module.css';

/** The services the sheet shows before See all. */
const TOP_SERVICES = 3;

export interface AboutOfferingsProps {
  /** Every service, in the order to show them (the most booked first). */
  services: HubServiceDto[];
  onOpenService: (service: HubServiceDto) => void;
  onSeeAllServices: () => void;
  happening: HappeningSoonItem[];
  onOpenEvent: (id: string) => void;
  onOpenSeries: (seriesId: string) => void;
  onSeeAllEvents: () => void;
}

export function AboutOfferings({ services, onOpenService, onSeeAllServices, happening, onOpenEvent, onOpenSeries, onSeeAllEvents }: AboutOfferingsProps) {
  if (services.length === 0 && happening.length === 0) return null;
  return (
    <div className={`${hubCss.page} ${css.inSheet}`}>
      {services.length > 0 && (
        <section className={css.services} aria-label="Services">
          <div className={hubCss.happeningHeader}>
            <h2 className={`${aboutCss.sectionTitle} ${css.title}`}>Services</h2>
            {services.length > TOP_SERVICES && (
              <button type="button" className={hubCss.sectionLink} onClick={onSeeAllServices}>
                See all {services.length}
                <ChevronRightIcon />
              </button>
            )}
          </div>
          <div className={`${bookCss.servicesList} ${css.list}`}>
            {services.slice(0, TOP_SERVICES).map((s) => (
              <ServiceCatalogCard key={s.id} service={s} onView={onOpenService} />
            ))}
          </div>
        </section>
      )}
      <HappeningSoon items={happening} onOpenEvent={onOpenEvent} onOpenSeries={onOpenSeries} onSeeAll={onSeeAllEvents} />
    </div>
  );
}
